import { render } from "./BaseSources.vue?vue&type=template&id=f983df10"
import script from "./BaseSources.vue?vue&type=script&lang=js"
export * from "./BaseSources.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BaseSources.vue?vue&type=style&index=0&id=f983df10&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__